/**
 * PuzzlesPage — practice puzzles for a domain.
 * Route: /puzzles/:domain
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PuzzleReviewSession from '../components/scenes/PuzzleReviewSession';
import LearnerNav from '../components/nav/LearnerNav';

const DOMAIN_LABELS = {
  ai: 'AI',
  ai_orchestrator: 'AI Orchestrator',
  ai_beginner: 'AI Beginner',
  ai_entrepreneur: 'AI Entrepreneur',
  football: 'Football IQ',
  lsat: 'LSAT Prep',
  sat: 'SAT Prep',
};

export default function PuzzlesPage() {
  const { domain } = useParams();
  const { user, learner } = useAuth();
  const navigate = useNavigate();
  const learnerId = learner?.learner_id || user?.learner_id;
  const domainLabel = DOMAIN_LABELS[domain] || (domain || '').replace(/_/g, ' ');

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg-primary, #0a0e1a)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LearnerNav />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '14px 20px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.03)',
        }}
      >
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: '#94a3b8',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          ← Dashboard
        </button>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#e2e8f0' }}>
          {domainLabel} — Practice Puzzles
        </h2>
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          padding: '32px 16px',
        }}
      >
        {learnerId ? (
          <div style={{ width: '100%', maxWidth: 720 }}>
            <PuzzleReviewSession
              learnerId={learnerId}
              domain={domain}
              onExit={() => navigate('/dashboard')}
            />
          </div>
        ) : (
          <p style={{ color: '#94a3b8' }}>Initializing session…</p>
        )}
      </div>
    </div>
  );
}
